import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './containers/manager/Manager';
import Review from './containers/review/Review';
import Error from './containers/error/Error';
import registerServiceWorker from './service/registerServiceWorker';
import {BrowserRouter, Route, Switch} from 'react-router-dom';
import {Provider} from 'react-redux';
import store from './redux/store';

ReactDOM.render(
    <Provider store={store}>
        <BrowserRouter>
            <Switch>
                <Route exact path={'/review/:code'} component={Review} />
                <Route exact path={'/:code'} component={App}/>                
                <Route exact path={'/'} component={App}/>
                <Route component={Error}/>
            </Switch>
        </BrowserRouter>
    </Provider>,
    document.getElementById('root')
);
registerServiceWorker();
